export const ReplaceIcon = () => {
  return (
    <svg
      fill="none"
      height="14"
      viewBox="0 0 14 14"
      width="14"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.57485 2.2C8.57485 1.54 9.11485 1 9.77485 1M12.1749 1C12.8349 1 13.3749 1.54 13.3749 2.2M13.3749 4.6C13.3749 5.26 12.8349 5.8 12.1749 5.8M9.77485 5.8C9.11485 5.8 8.57485 5.26 8.57485 4.6M1.97485 4L3.77485 5.8L5.57485 4"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.77515 5.8V2.8C3.77515 1.78 4.55515 1 5.57515 1H6.17515"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.975 8.19971H2.575C1.91226 8.19971 1.375 8.73697 1.375 9.39971V11.7997C1.375 12.4624 1.91226 12.9997 2.575 12.9997H4.975C5.63774 12.9997 6.175 12.4624 6.175 11.7997V9.39971C6.175 8.73697 5.63774 8.19971 4.975 8.19971Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
